// assets/cart.grouping.js
window.CartMethodsGrouping = {
    getTotalQtyByGroupId(groupID,curentId) {
        let result = 0;

        this.cartItems.forEach(
            el => {
                if(el.properties._groupID == groupID && el.id !=curentId && el.product_title != "Associated Fee"){
                    result += el.quantity;
                }
            }
        );

        return result;
    },

    sortCartItems() {
        this.productIds = [];
        // Rebuilt from cartItems on every pass: a stale entry for an already removed fee
        // line makes removeAssocProd() send its key again, and update.js falls back to
        // variant_id for a missing key, wiping another group's pooled fee line
        this.assocToProduct = {};
        this.subtotalPrice = 0;
        let subtotalDiscounts = 0;

        for(let item of this.cartItems ) {

            if(item) {
                if(!this.productIds.includes(item.properties._groupID) && !(item.title || '').includes("Associated Fee")) {
                    this.productIds.push(item.properties._groupID);

                    // Reorder properties so Imprint location + Imprint Method
                    // appear first regardless of insertion order from Shopify
                    const raw = item.properties;
                    const reordered = {};
                    if ('Imprint location' in raw) reordered['Imprint location'] = raw['Imprint location'];
                    if ('Imprint Method'   in raw) reordered['Imprint Method']   = raw['Imprint Method'];
                    Object.keys(raw).forEach(k => { if (!(k in reordered)) reordered[k] = raw[k]; });
                    this.properties[item.properties._groupID] = reordered;
                    this.productTitle[item.properties._groupID] = {};

                    if(item.product_type === "calendar_sku") {
                        this.productTitle[item.properties._groupID]['title'] = this.properties[item.properties._groupID]['_Grouped Product name']  + " - " + item.properties["Imprint Method"];
                        this.productTitle[item.properties._groupID]['url'] = item.properties._productUrl;
                    } else {
                        this.productTitle[item.properties._groupID]['title'] = item.product_title  + " - " + item.properties["Imprint Method"];
                        this.productTitle[item.properties._groupID]['url'] = item.properties._productUrl;
                    }
                    this.qtyIncriment[item.properties._groupID] = Object.hasOwn(item.properties, '_qtyIncrement')
                        ? this.properties[item.properties._groupID]['_qtyIncrement']
                        : 1;
                }
                if((item.title || '').includes("Associated")) {
                    this.assocToProduct[item.properties._groupID] = item;
                }

                this.subtotalPrice += item[this.linePriceProperty];

                if(item.discounts) {
                    for (let discount of item.discounts){
                        subtotalDiscounts += discount.amount;
                    }
                }
            }
        }
        this.subtotalDiscounts = subtotalDiscounts;
        this.calculateFee();
    },

    removeAssocProd() {
        for (const property in this.assocToProduct) {
            if(!this.productIds.includes(property)) {
                // Remove this group's fee line only (by line key): a pooled fee variant
                // may also be the fee line of other groups.
                let updatesData = {};
                let feeLine = this.assocToProduct[property];
                updatesData[feeLine['key'] || feeLine['variant_id']] = 0;

                delete this.assocToProduct[property];
                this.removeCartLine(updatesData);
                this.calculateFee();
            }
        }
    },

    removeMinQtyAndPriceChange(groupId) {
        let result = true;

        this.storageCart.items.forEach(
            item => {
                if (item.properties._groupID == groupId && item.product_title != "Associated Fee") {
                    result = false;
                }
            }
        );

        return result;
    },
};